import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface User {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    role: string;
    guestId?: string;
}

interface AuthState {
    user: User | null;
    accessToken: string | null;
    refreshToken: string | null;
    guestId: string | null;
    isAuthenticated: boolean;

    // Actions
    setAuth: (data: { user: User; accessToken: string; refreshToken: string }) => void;
    setTokens: (accessToken: string, refreshToken: string) => void;
    setGuestId: (id: string) => void;
    clearGuestId: () => void;
    logout: () => void;
}

export const useAuthStore = create<AuthState>()(
    persist(
        (set) => ({
            user: null,
            accessToken: null,
            refreshToken: null,
            guestId: null,
            isAuthenticated: false,

            setAuth: (data) => set({
                user: data.user,
                accessToken: data.accessToken,
                refreshToken: data.refreshToken,
                isAuthenticated: true
            }),

            setTokens: (accessToken, refreshToken) => set((state) => ({
                ...state,
                accessToken,
                refreshToken,
                isAuthenticated: true
            })),

            setGuestId: (id) => set((state) => ({
                ...state,
                guestId: id
            })),

            clearGuestId: () => set((state) => ({
                ...state,
                guestId: null
            })),

            logout: () => set((state) => ({
                ...state,
                user: null,
                accessToken: null,
                refreshToken: null,
                isAuthenticated: false
                // Note: we intentionally keep guestId so the user
                // remains a guest after logging out
            }))
        }),
        {
            name: 'user-auth' // Key in localStorage
        }
    )
);
